import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FormDefinition } from '../form-definition';
import { MessageService } from '../message.service';
import { ProcessInstance } from '../process-instance';
import { RepoService } from '../repo.service';
import { ProfileService } from '../profile.service';

@Component({
    selector: 'app-process-start-detail',
    templateUrl: './process-start-detail.component.html',
    styleUrls: ['./process-start-detail.component.scss'],
    standalone: false
})
export class ProcessStartDetailComponent implements OnInit {

  form: FormDefinition;
  filledFormDef: FormDefinition;
  procInst: ProcessInstance;
  procDefId: string;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private repoService = inject(RepoService);
  private messageService = inject(MessageService);
  private profileService = inject(ProfileService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.messageService.set(`Starting process...`);
    this.procDefId = this.route.snapshot.paramMap.get('id');

    // Wait for profile to be loaded before fetching form
    if (this.profileService.isAuthenticated()) {
      this.loadForm();
    } else {
      // Listen for profile loaded event
      window.addEventListener('profile:loaded', () => {
        this.loadForm();
      }, { once: true });
    }
  }

  private loadForm(): void {
    this.repoService.getFormDefinition(this.procDefId)
        .subscribe(form => {
          this.form = form;
          this.cdr.detectChanges();
        });
  }

  onStart(form: FormDefinition): void {
    // a bit of magic here: use taskId as form id rendered by FormComponent
    const trgt = document.getElementById(this.form.id) as HTMLFormElement;
    if (trgt.checkValidity()) {
      this.filledFormDef = form;
      this.messageService.set(`Submitting ${form.key}`);
      this.repoService
        .startInstance(this.procDefId, this.filledFormDef)
        .subscribe(procInst => {
          this.procInst = procInst;
          this.cdr.detectChanges();
          this.router.navigate(['/process-starters']);
        });
    } else {
      this.messageService.set(`Cannot submit while one or more responses are invalid...`, 'error');
      document.querySelectorAll(':invalid').forEach(d => {
        d.dispatchEvent(new MouseEvent('blur', {
          view: window,
          bubbles: true,
          cancelable: true
        }));
      });
    }
  }
}
